module.exports = {
  chat_sent_image: 'hat ein Bild gesendet',
  chat_sent_file: 'hat eine Datei gesendet',
  chat_sent_video: 'hat ein Video gesendet',
  update_available: 'Aktualisierung verfügbar',
  deleted_tokens: 'Du bist auf einem anderen Gerät ausgeloggt worden. | Du bist auf {x} anderen Geräten ausgeloggt worden.',
  error: 'Fehler',
  reload_to_update: 'Eine neue Version der App ist verfügbar. Aktualisiere die Seite um die neuste Version zu aktivieren.',
  reload_app: 'App neu laden',
  info: 'Info',
  failed_to_send_message: 'Die Nachricht konnte nicht gesendet werden.',
  title: 'Benachrichtigungen',
  max_file_count: 'Du kannst nicht mehr als {count} Dateien hochladen.',
  max_file_size: 'Du kannst keine Datei hochladen, die größer als {size} MB ist!',
  quiz: 'Quiz-Battle',
}
